import React from "react";
import { BellRing, Hourglass, RotateCw, UserX } from "lucide-react";

// Quem chegou depois do primeiro espera aqui até ele liberar a entrada pelo
// celular dele. A tela se atualiza sozinha (useParticipantes consulta a cada
// 3 s) e some quando a liberação chega. Se o anfitrião recusar, dá pra pedir
// de novo; e, se ele sumiu, o garçom resolve — por isso o botão de chamar.
export default function TelaAguardando({
  mesa, anfitriao, status, darkMode, chamarGarcom, chamadoAberto, onChamarGarcom, onPedirDeNovo,
}) {
  const recusado = status === "recusado";
  const quem = anfitriao || "Quem abriu a mesa";
  const fundo = darkMode ? "bg-zinc-950 text-zinc-100" : "bg-white text-zinc-900";
  const Icone = recusado ? UserX : Hourglass;

  return (
    <div className={`fixed inset-0 z-[60] flex flex-col items-center justify-center px-7 text-center ${fundo}`}
         data-e2e="mesa-aguardando" data-status={status}>
      <p className="text-xs uppercase tracking-widest opacity-50 mb-6">
        {(mesa?.nome || `Mesa ${mesa?.numero ?? ""}`).toUpperCase()}
      </p>
      <div className={`w-20 h-20 rounded-full flex items-center justify-center mb-5 ${recusado ? "bg-red-500/10 text-red-500" : "bg-primary/10 text-primary"}`}>
        <Icone className={`w-10 h-10 ${recusado ? "" : "animate-pulse"}`} />
      </div>
      {recusado ? (
        <>
          <h1 className="text-2xl font-black leading-tight mb-2">Sua entrada não foi liberada</h1>
          <p className="text-sm opacity-70 max-w-xs">
            {quem} não liberou o seu acesso a esta mesa. Fale com {anfitriao || "a mesa"} e peça de novo, ou chame o garçom.
          </p>
        </>
      ) : (
        <>
          <h1 className="text-2xl font-black leading-tight mb-2">Aguardando {quem} liberar</h1>
          <p className="text-sm opacity-70 max-w-xs">
            Pedimos para {quem} liberar a sua entrada na mesa pelo celular. Assim que liberar, o cardápio abre sozinho.
          </p>
        </>
      )}
      <div className="w-full max-w-sm mt-8 space-y-2">
        {recusado ? (
          <button type="button" onClick={onPedirDeNovo} data-e2e="mesa-pedir-de-novo"
            className="w-full h-14 rounded-full bg-primary text-primary-foreground font-black flex items-center justify-center gap-2 active:scale-[0.98] transition">
            <RotateCw className="w-5 h-5" /> PEDIR DE NOVO
          </button>
        ) : null}
        {chamarGarcom ? (
          <button type="button" onClick={onChamarGarcom} disabled={chamadoAberto} data-e2e="mesa-aguardando-garcom"
            className={`w-full h-12 rounded-full border-2 text-sm font-bold flex items-center justify-center gap-1.5 transition ${
              chamadoAberto ? "border-emerald-500/40 text-emerald-500" : "border-primary/40 text-primary active:scale-[0.98]"
            }`}>
            <BellRing className="w-4 h-4" /> {chamadoAberto ? "Garçom a caminho" : "Chamar garçom"}
          </button>
        ) : null}
      </div>
    </div>
  );
}
